import { Component, OnInit } from '@angular/core';
import { ICountry } from '../../../../core/models/country.interface';
import { ConstantService } from '../../../../core/services/constant.service';
import { UserService } from '../../../../core/services/user.service';
import { IShipmentPriceItemData,
    ISPItemSizeRestriction,
    ISubCarrierPrice,
    ITypeActivityPrice,
    IVendor } from '../../models/shipment-price.interface';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'eci-price-item-detail',
    templateUrl: './price-item-detail.component.html',
    styleUrls: ['./price-item-detail.component.scss']
})
export class PriceItemDetailComponent implements OnInit {

    public priceItemId: number;
    public priceItemData: IShipmentPriceItemData;
    public subCarrierPrices: ISubCarrierPrice[];
    public typeActivityPrices: ITypeActivityPrice[];
    public sizeRestrictions: ISPItemSizeRestriction[];
    public vendorData: IVendor;
    public countriesList: ICountry[];

    protected displayFields: string[][] = [
        [ 'pricingId', 'serviceType', 'serviceSubType', 'serviceProvider', 'vendor', 'defaultMargin', 'origin', 'coverage' ],
        [ 'hasSubCarrier', 'origin', 'coverage', 'surcharges', 'fixMargin', 'cost', 'price', 'currency' ],
        [ 'typeUnitOfMeasurement' ],
    ];
    public itemNames: string[] = [
        'Item', 'Last Mile', 'Fulfillment',
    ];
    public displayedFields: string[] = this.displayFields[0];
    public priceItemName: string = this.itemNames[0];
    public title: string = 'Detailed Prices List';

    constructor(
        public router: Router,
        private userSvc: UserService,
        private route: ActivatedRoute,
        private constSvc: ConstantService,
    ) {}

    private get correctDisplayFields(): string[] {
        return this.displayedFields.concat(this.displayFields[+this.priceItemData.serviceId]);
    }

    ngOnInit() {
        this.route.data.subscribe(data => {
            if (data['data']) {
                this.priceItemData = data['data'];
                this.subCarrierPrices = data['data']?.subCarrierPrices;
                this.sizeRestrictions = data['data']?.sizeRestrictions;
                this.vendorData = data['data']?.vendor;
                this.priceItemId = data['data']?.id;
                this.typeActivityPrices = data['data']?.typeActivityPrices;
            }});
        this.getListOfCountries();

        if (this.priceItemData?.serviceId) {
            this.priceItemName = this.itemNames
                .find((name) => this.priceItemData?.shipmentService?.name?.toUpperCase() === name.toUpperCase()) || 'Last mile';
        }

        this.displayedFields = this.correctDisplayFields;
    }

    private getListOfCountries(
        page: number = 1,
        q: string = '',
        limit: number = 1000,
        withTaxRate: boolean = false,
    ): void {
        this.constSvc.getAvailableCountriesForScroll(page, limit, false, q, withTaxRate).subscribe(data => {
            if (data) {
                this.countriesList = data.items;
            }
        });
    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

}
